/**
 * Mobile "tap to reveal sizes" behaviour for product cards.
 *
 * On mobile (no real hover), the first tap on a card image does NOT navigate to
 * the product: instead it reveals the size overlay and shows the product's second
 * image. A second tap on the image navigates as usual. Tapping another card closes
 * the previously revealed one; tapping outside closes it too. The card title always
 * navigates.
 *
 * Only active when the global `sizes_mobile_tap` setting is on — the snippet marks
 * eligible cards with `card-size-selector[data-mobile-reveal="true"]`, and this
 * script is only loaded when the setting is enabled.
 *
 * Uses a single capture-phase listener so preventDefault runs before the card's
 * own click handlers (navigation + view transition, which both respect
 * defaultPrevented).
 */
(function () {
  const REVEALED_CLASS = 'is-sizes-revealed';
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  /** @param {Element} card */
  function getSlideshow(card) {
    return card.querySelector('slideshow-component');
  }

  /** @param {Element} card */
  function hasSecondSlide(card) {
    const slideshow = getSlideshow(card);
    return slideshow ? slideshow.querySelectorAll('slideshow-slide').length > 1 : false;
  }

  /** @param {Element} card */
  function revealCard(card) {
    card.classList.add(REVEALED_CLASS);
    const slideshow = getSlideshow(card);
    if (slideshow && typeof (/** @type {any} */ (slideshow).next) === 'function' && hasSecondSlide(card)) {
      /** @type {any} */ (slideshow).next(undefined, { animate: true });
    }
  }

  /** @param {Element} card */
  function closeCard(card) {
    if (!card.classList.contains(REVEALED_CLASS)) return;
    card.classList.remove(REVEALED_CLASS);
    const slideshow = getSlideshow(card);
    if (slideshow && typeof (/** @type {any} */ (slideshow).previous) === 'function' && hasSecondSlide(card)) {
      /** @type {any} */ (slideshow).previous(undefined, { animate: true });
    }
  }

  /** @param {Element | null} keep - Card to leave open (if any). */
  function closeRevealedExcept(keep) {
    for (const card of document.querySelectorAll('product-card.' + REVEALED_CLASS)) {
      if (card !== keep) closeCard(card);
    }
  }

  /** @param {MouseEvent} event */
  function onClick(event) {
    if (!mobileQuery.matches) return;
    const target = event.target;
    if (!(target instanceof Element)) return;

    const tappedCard = target.closest('product-card');

    // Any tap closes other revealed cards (only one open at a time).
    closeRevealedExcept(tappedCard);

    const galleryLink = target.closest("[ref='cardGalleryLink']");
    if (!galleryLink) return; // size button, title, or outside → normal behaviour.

    const card = galleryLink.closest('product-card');
    if (!card) return;

    // Only cards that actually render the mobile-reveal size selector.
    if (!card.querySelector("card-size-selector[data-mobile-reveal='true']")) return;

    // Second tap on an already-revealed card → let it navigate.
    if (card.classList.contains(REVEALED_CLASS)) return;

    // First tap → reveal instead of navigating (blocks nav + view transition).
    event.preventDefault();
    revealCard(card);
  }

  document.addEventListener('click', onClick, true);
})();
